export default __webpack_public_path__ + "static/media/hg_pro_logo.b89590ee.png";